export default __webpack_public_path__ + "static/media/3.ac9724db.png";